module.exports = __webpack_public_path__ + "static/img/sjOne.472c172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjOne.jpg
// module id = 2tNv
// module chunks = 1